import $axios from '~/plugins/axios';

import { Admin, AdminRequest, AdminStatusRequest, Api } from '~/api';
import { buildModule } from '../utils';
import { Dict, removeKey } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedAdmins: {} as Dict<Admin>,
	})
	.withGetters({
		byId: state => (adminId: number): Admin | null => (
			state.storedAdmins[adminId] ?? null
		),
	})
	.withMutations({
		STORE_ADMIN (state, admin: Admin) {
			state.storedAdmins = {
				...state.storedAdmins,
				[admin.id]: admin,
			};
		},
		REMOVE_STORED_ADMIN (state, id: number) {
			state.storedAdmins = removeKey(state.storedAdmins, id);
		},
	})
	.withActions({
		async get ({ commit }, id: number) {
			const { data } = await api.get(`/admin/${ id }`);
			commit('STORE_ADMIN', data.payload);
		},
		async update (
			{ commit },
			{ id, ...request }: AdminRequest & { id: number },
		) {
			const { data } = await api.put(`/admin/${ id }`, request);
			commit('STORE_ADMIN', data);
		},
		async post ({ commit }, request: AdminRequest) {
			const { data } = await api.post('/admin', request);
			commit('STORE_ADMIN', data);
		},
		async updateState (
			{ commit },
			{ id, ...body }: { id: number } & AdminStatusRequest,
		) {
			const { data } = await api.put(`/admin/${ id }/status`, body);
			commit('STORE_ADMIN', data);
		},
		async deleteAdmin ({ commit }, id: number) {
			const { data } = await api.delete(`/admin/${ id }`);
			if (data.status === 'ok') { commit('REMOVE_STORED_ADMIN', id); }
		},
	});
